import { FeatureTooltipBadgeComponent } from './feature-tooltip-badge.component';

export { FeatureTooltipBadgeComponent };
